export default __webpack_public_path__ + "static/media/Russia.6d47bc44.svg";